export enum AvailableTranslateLanguages {
  EN = 'English',
  RU = 'Russian',
}
